<template>
  <div>
      <div class="head">
        <div class="title">
            <div>名称</div>
            <el-input placeholder="名称" v-model="titlecount" class="input-with-select" clearable></el-input>
            <el-button type="primary" size="mini" icon="el-icon-search" class="mybtn"  @click="search" style="margin-left:10px">查找</el-button>
      </div>
      </div>
      <div class="com-content">
         <div class="content" ref="myHeight">
       
        <el-table
        :data="tableData"
        tooltip-effect="dark"
       
        >
        <el-table-column prop="title" label="名称"  align='center'></el-table-column>
        <el-table-column prop="describle" label="描述"  align='center'></el-table-column>
        <el-table-column prop="type" label="类型" align='center' ></el-table-column>
        <el-table-column
            label="图片"
            align='center'
            >
            <template slot-scope="scope">
              <el-image  class="img" fit="contain"  :src="scope.row.url"></el-image>
            </template>
        </el-table-column>
        
      </el-table>
      </div>
      </div>
     
    
  </div>
</template>
<script>
import {formatDate} from '../utils/utils'
export default {
    data () {
      return {
        tableData:[
          {
            title:'发电机',
            describle:'',
            type:'静态',
            url:require('@/assets/1.png')
          },
          {
            title:'变压器',
            describle:'',
            type:'静态',
            url:require('@/assets/2.png')
          },
          {
            title:'变压器',
            describle:'',
            type:'静态',
            url:require('@/assets/3.png')
          },
          {
            title:'变压器',
            describle:'',
            type:'静态',
            url:require('@/assets/4.png')
          },
          {
            title:'变压器',
            describle:'',
            type:'静态',
            url:require('@/assets/5.png')
          },
          {
            title:'消弧线圈',
            describle:'',
            type:'静态',
            url:require('@/assets/6.png')
          },
          {
            title:'接地线',
            describle:'',
            type:'静态',
            url:require('@/assets/7.png')
          },
          {
            title:'表计',
            describle:'',
            type:'静态',
            url:require('@/assets/8.png')
          },
          {
            title:'传感器',
            describle:'',
            type:'静态',
            url:require('@/assets/9.png')
          },
          {
            title:'切换阀',
            describle:'',
            type:'静态',
            url:require('@/assets/10.png')
          },
          {
            title:'切换阀',
            describle:'',
            type:'静态',
            url:require('@/assets/11.png')
          },
          {
            title:'切换阀',
            describle:'',
            type:'静态',
            url:require('@/assets/12.png')
          },
          {
            title:'切换阀',
            describle:'',
            type:'静态',
            url:require('@/assets/13.png')
          },
          {
            title:'事故配压阀',
            describle:'',
            type:'静态',
            url:require('@/assets/14.png')
          },
          {
            title:'减压阀',
            describle:'',
            type:'静态',
            url:require('@/assets/15.png')
          },
          {
            title:'单向阀',
            describle:'',
            type:'静态',
            url:require('@/assets/16.png')
          },
          {
            title:'变压器',
            describle:'',
            type:'静态',
            url:require('@/assets/17.png')
          },
          {
            title:'风阀',
            describle:'',
            type:'静态',
            url:require('@/assets/18.png')
          },
          {
            title:'取水口',
            describle:'',
            type:'静态',
            url:require('@/assets/19.png')
          },
          {
            title:'滤水器',
            describle:'',
            type:'静态',
            url:require('@/assets/20.png')
          },
          {
            title:'冷却器',
            describle:'',
            type:'静态',
            url:require('@/assets/21.png')
          },
          {
            title:'主配压阀',
            describle:'',
            type:'静态',
            url:require('@/assets/22.png')
          },
          {
            title:'组合阀',
            describle:'',
            type:'静态',
            url:require('@/assets/23.png')
          },
          {
            title:'泵',
            describle:'',
            type:'静态',
            url:require('@/assets/24.png')
          },
          {
            title:'接力器',
            describle:'',
            type:'静态',
            url:require('@/assets/25.png')
          },
          {
            title:'水轮机',
            describle:'',
            type:'静态',
            url:require('@/assets/26.png')
          },
          {
            title:'开关',
            describle:'合位',
            type:'动态',
            url:require('@/assets/27.png')
          },
          {
            title:'开关',
            describle:'分位',
            type:'动态',
            url:require('@/assets/28.png')
          },
          {
            title:'闸刀',
            describle:'合位',
            type:'动态',
            url:require('@/assets/29.png')
          },
          {
            title:'闸刀',
            describle:'分位',
            type:'动态',
            url:require('@/assets/30.png')
          },
          {
            title:'阀门',
            describle:'开启',
            type:'动态',
            url:require('@/assets/31.png')
          },
          {
            title:'阀门',
            describle:'关闭',
            type:'动态',
            url:require('@/assets/32.png')
          },
          {
            title:'开关抽屉',
            describle:'工作位置',
            type:'动态',
            url:require('@/assets/33.png')
          },
          {
            title:'开关抽屉',
            describle:'检修位置',
            type:'动态',
            url:require('@/assets/34.png')
          },
          {
            title:'电动阀门',
            describle:'开启',
            type:'动态',
            url:require('@/assets/35.png')
          },
          {
            title:'电动阀门',
            describle:'关闭',
            type:'动态',
            url:require('@/assets/36.png')
          },
          {
            title:'接地桩',
            describle:'接地',
            type:'动态',
            url:require('@/assets/37.png')
          },
          {
            title:'接地桩',
            describle:'未接地',
            type:'动态',
            url:require('@/assets/38.png')
          },
          {
            title:'切换开关',
            describle:'',
            type:'动态',
            url:require('@/assets/39.png')
          },
          {
            title:'切换开关',
            describle:'',
            type:'动态',
            url:require('@/assets/40.png')
          },
          {
            title:'双头开关',
            describle:'带1位置',
            type:'动态',
            url:require('@/assets/41.png')
          },
          {
            title:'双头开关',
            describle:'带2位置',
            type:'动态',
            url:require('@/assets/42.png')
          },
          {
            title:'双头开关',
            describle:'退出',
            type:'动态',
            url:require('@/assets/43.png')
          }
        ],
       
        titlecount:"",
        clientHeight:0,
        dialogVisible:false, 
     }
   },
    computed:{
      
    },
    components:{
    },
    watch:{
      // 如果 `clientHeight` 发生改变，这个函数就会运行
      clientHeight: function () {
        this.changeFixed(this.clientHeight)
      },
    },
    mounted(){
      this.clientHeight =   `${document.documentElement.clientHeight}`-230         
      window.onresize = function temp() {
        this.clientHeight = `${document.documentElement.clientHeight}`-230 ;
      };
      // //console.log( this.clientHeight)
      
    },
    methods:{
        changeFixed(clientHeight){ //动态修改样式
        this.$refs.myHeight.style.maxHeight = clientHeight+'px';
      },  
       //搜索
      search(){
        let searchObj=this.titlecount; 
        let data = this.tableData.filter(tableData =>{
           if(tableData.title == searchObj || tableData.title.indexOf(searchObj)!= -1){
             return true
           }
        });
        this.tableData = data;
      },
     
    }
}

</script>
<style scoped>


.head{
    padding: 20px;
    width: 80%;
    margin: 0 auto;
}
.title{
    display: flex;                            
    font-size: 14px;
    margin-bottom: 20px;
    margin: 10px;

}
 .title div:first-child{
    width: 40px;line-height: 40px;margin-right: 10px;
  }
    .title div:nth-child(2){
    height: 30px;
    width:250px;
    margin-right: 50px  ;
  }
/* .mybtn{
  height: 30px;
  margin-top: 15px;
  margin-left: 20px !important;
} */
.com-content{
   width: 80%;
   margin: 0 auto;
}
.content{ 
  
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
}


.btn{
  display: flex;
  /* text-align: left; */
  font-size: 14px;
  line-height: 34px;
  /* margin-left: 10px; */
  padding-left: 15%;
  color: #666;
  font-family: verdana;
  
}
.edi{
  display: flex;
}
.pagination{
  
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.img{
  width: 60px;
  height: 60px;
  background-size: 100% 100%
}
</style>


// WEBPACK FOOTER //
// src/components/componentList.vue